import { render, staticRenderFns } from "./HeaderUserBlockPopup.vue?vue&type=template&id=1d7524a6&"
import script from "./HeaderUserBlockPopup.vue?vue&type=script&lang=js&"
export * from "./HeaderUserBlockPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports